// extracted by mini-css-extract-plugin
export var bottom = "globe-traffic-animation-module--bottom--a3dff";
export var fill = "globe-traffic-animation-module--fill--665a8";
export var left = "globe-traffic-animation-module--left--15706";
export var mapLabel = "globe-traffic-animation-module--mapLabel--3af2d";
export var noPointer = "globe-traffic-animation-module--noPointer--1ca7a";
export var right = "globe-traffic-animation-module--right--d8b8c";
export var top = "globe-traffic-animation-module--top--e11fa";
export var visible = "globe-traffic-animation-module--visible--a3290";